import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { validateGST } from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { InputField } from "../../../../Components/formElements/InputField";
// import CustomerItemService from "../../../../services/customer_v2_appCommonService";
// import toast from "react-hot-toast";
// import { FormInput } from "lucide-react";

const GetCustomerByGSTModal = React.forwardRef((props, ref) => {
  const [formData, setFormData] = useState({
    customerGst: "",
  });

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  const custGSTData = {
    organisationName: "Raju",

    address: "#123  HSR layout 4th sector, Bangalore 560001",

    city: "Bangalore", //not in gst

    state: "Karnataka",

    cityPostalCode: "560001",
  };

  const [getErrorFields, setErrorFields] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getFailureModal, setFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  // eslint-disable-next-line
  const [disable, setDisabled] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    // If customerGst is empty, set getGstNr to false
    if (name === "customerGst" && value.trim() === "") {
      setGstNr(false);
    }
  };

  const handleSubmit = async () => {
    const requiredFields = [];

    if (!formData.customerGst) {
      requiredFields.push("GST Number is required");
    } else if (!validateGST(formData.customerGst)) {
      requiredFields.push("* Invalid GST Number.");
    }

    if (requiredFields.length > 0) {
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    const finalData = {
      ...formData,
      organisationName: custGSTData?.organisationName,
      address: custGSTData?.address,
      city: custGSTData?.city,
      state: custGSTData?.state,
      cityPostalCode: custGSTData?.cityPostalCode,
      gstNumber:formData?.customerGst
    };
    if (props?.onSave) {
      props.onSave(finalData);
    }

    // setDisabled(true);
    /*   try {
      await CustomerItemService.sendEmailForLoading(formData).then((item) => {
        if (item?.status === 200) {
          // console.log("item", item);
          toast.success(
            `Mail Sent ${item?.message}` || "Mail send successfully",
            {
              duration: 2000,
              position: "top-right",
            }
          );
        } else {
          console.error("Failed to send invitation:");
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setDisabled(false);
    } */

    // props?.onSubmit(formData);
    props?.onHide();
  };
  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  const [getGstNr, setGstNr] = useState(false);
  const handleget = () => {
    const requiredFields = [];

    if (!formData.customerGst) {
      requiredFields.push("GST Number is required");
    } else if (!validateGST(formData.customerGst)) {
      requiredFields.push("* Invalid GST Number.");
    }

    if (requiredFields.length > 0) {
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }
    setGstNr(true);

    //call gst api here fetch the data set in  setFormData
    // setDisabled(true);
    /*   try {
      await CustomerItemService.sendEmailForLoading(formData).then((item) => {
        if (item?.status === 200) {
          // console.log("item", item);
          toast.success(
            `Mail Sent ${item?.message}` || "Mail send successfully",
            {
              duration: 2000,
              position: "top-right",
            }
          );
        } else {
          console.error("Failed to send invitation:");
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setDisabled(false);
    } */

    // props?.onSubmit(formData);
  };
  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Get Customer By GST</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <Col xs={10} md={4} lg={4} className="commTopButtonRightLeftPadding">
            <InputField
              className="inputBox"
              label="GST Number"
              name="customerGst"
              id="customerGst"
              extraLabel=""
              value={formData?.customerGst || ""}
              onChange={handleChange}
            />
          </Col>
          <Col
            xs={2}
            md={2}
            lg={2}
            className="d-flex justify-content-start align-items-center"
          >
            <button
              onClick={handleget}
              disabled={disable}
              className="btn btn-primary"
              style={{ marginTop: "20px" }}
            >
              Get
            </button>
          </Col>
          {getGstNr && (
            <Row>
              <Col
                xs={5}
                md={5}
                lg={5}
                className="commTopButtonRightLeftPadding px-6 py-4 bg-white rounded-2xl shadow-md"
              >
                <p className="fs-6 fw-bold text-black"> As Per Portal </p>
                <div className="space-y-2 text-md">
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      Trade Name :
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      {custGSTData?.organisationName}
                    </span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      Legal Name :
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      {custGSTData?.organisationName}
                    </span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      Address :
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      {custGSTData?.address}
                    </span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      City :
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      {custGSTData?.city}
                    </span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      State :
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      {custGSTData?.state}
                    </span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      Pincode :
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      {custGSTData?.cityPostalCode}
                    </span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      State :
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      {custGSTData?.state}
                    </span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      GSTIN/UIN:
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      Active
                    </span>
                  </div>
                </div>
              </Col>
              <Col
                xs={1}
                md={1}
                lg={1}
                className="d-flex justify-content-center"
              >
                <div className="border-l-2 border-gray-400 h-100"></div>
              </Col>
              <Col
                xs={6}
                md={6}
                lg={6}
                className="commTopButtonRightLeftPadding px-6 py-4 bg-white rounded-2xl shadow-md"
              >
                <p className="fs-6 fw-bold text-black"> As Per Books </p>
                <div className="space-y-2 text-md">
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      Name :
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      {custGSTData?.organisationName}
                    </span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      Mailing Name :
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      {custGSTData?.organisationName}
                    </span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      Address :
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      {custGSTData?.address}
                    </span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      PAN/IT No :
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      CEWPK5327J
                    </span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      City :
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      {custGSTData?.city}
                    </span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      State :
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      {custGSTData?.state}
                    </span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      Pincode :
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      {custGSTData?.cityPostalCode}
                    </span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      State :
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1">
                      {custGSTData?.state}
                    </span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold text-gray-700 w-32 shrink-0">
                      Registration Type: 
                    </span>
                    <span className="text-gray-500 font-normal break-words flex-1 ">
                      Active
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={handleSubmit}
          disabled={disable}
          className="btn btn-primary"
        >
          Submit
        </button>
        <button onClick={props?.onHide} className="btn btn-danger">
          Cancel
        </button>
      </Modal.Footer>

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
    </Modal>
  );
});

export default GetCustomerByGSTModal;
